export default "__VITE_ASSET__CEdGt0Xk__"